import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UiLicenseChartComponent } from '@components/shared/license/ui-license-chart.component';
import { UiLineChartModule } from '@components/ui-chart/line/ui-line-chart.module';
import { SharedModule } from '@modules';
import { TranslateModule } from '@ngx-translate/core';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MatProgressSpinnerModule,
        MatCardModule,
        TranslateModule,
        UiLineChartModule,
        UiSuggestModule,
        UiNgLetModule,
        UiContentLoaderModule,
    ],
    declarations: [
        UiLicenseChartComponent,
    ],
    exports: [
        UiLicenseChartComponent,
    ],
})
export class UiLicenseChartModule { }
